import * as yup from 'yup';

export interface StandardMetricsFormValues {
  clientId: string;
  clientSecret: string;
}

export function standardMetricsConfigSchema(isExistingConfig: boolean) {
  return yup.object({
    clientId: yup.string().trim().required('Client ID is required'),
    clientSecret: isExistingConfig
      ? yup.string().default('')
      : yup.string().trim().required('Client Secret is required'),
  });
}

export function getDefaultStandardMetricsConfig(): StandardMetricsFormValues {
  return {
    clientId: '',
    clientSecret: '',
  };
}
